// extracted by mini-css-extract-plugin
export default {"shadow":"unboxing_shadow__VXiMS","border":"unboxing_border__ZJ7Qg","unboxing":"unboxing_unboxing__Ym9-m"};